
























































import Vue from 'vue'
import CreateDialog from '@/components/CreateDialog.vue'

export default Vue.extend({
  components: {
    appCreateDialog: CreateDialog,
  },
  data() {
    return {
      editedColor: '',
      colors: {},
      newColors: {},
    }
  },
  methods: {
    setColor(index: string) {
      this.editedColor = index
    },
    onSuccess() {
      Object.keys(this.$vuetify.theme.themes[this.theme]).forEach(color => {
        this.$vuetify.theme.themes[this.theme][color] = (this.newColors as {
          [key: string]: string
        })[color]
      })
      localStorage.setItem('theme', JSON.stringify(this.$vuetify.theme.themes))
      this.$emit('input', false)
    },
    onReject() {
      this.newColors = this.$vuetify.theme.themes[this.theme]
      this.$emit('input', false)
    },
  },
  computed: {
    theme(): 'dark' | 'light' {
      return this.$vuetify.theme.dark ? 'dark' : 'light'
    },
  },
  watch: {
    '$vuetify.theme.dark'(): void {
      const theme = this.theme
      this.colors = this.$vuetify.theme.themes[theme]
      this.newColors = { ...this.$vuetify.theme.themes[theme] }
    },
  },
  created() {
    this.colors = this.$vuetify.theme.themes[this.theme]
    this.newColors = { ...this.$vuetify.theme.themes[this.theme] }
  },
})
